<template>
  <Frame>
    <template v-slot:header>
      <div class="header-filter">
        <van-image
          width="24"
          height="24"
          :src="require('@/assets/image/common/filter.png')"
          @click="showDialog"
        />
      </div>
    </template>
    <template v-slot:body>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finished && list.length >= 10 ? '--没有更多了--' : ''"
          @load="onLoad"
        >
          <RecordItem
            :key="index"
            :detail="item"
            v-for="(item, index) in list"
            @navigate="navigateDetail"
          />
          <van-empty
            v-if="list.length <= 0 && finished"
            class="custom-image"
            :image="require('@/assets/image/no-data.png')"
            description="暂无数据"
          />
        </van-list>
      </van-pull-refresh>
    </template>
    <template v-slot:footer>
      <div class="footer">
        <FilterDialog
          v-if="filterDialogShow"
          title="筛选"
          @right="filterDialogCancleEvt"
          @reset="filterDialogResetEvt"
          @ok="filterDialogOkEvt"
        >
          <FilterStatusList
            ref="statusFilter"
            title="筛选"
            :default-ids="searchStatus"
            :list="filterList"
          />
        </FilterDialog>
      </div>
    </template>
  </Frame>
</template>

<script>
import Frame from "@/components/frame.vue";
import RecordItem from "./recordItem.vue";
import FilterDialog from "@/components/filterDialog.vue";
// import FilterStatusList from "./filterStatusList.vue";
import FilterStatusList from "@/components/filterStatusList.vue";

import { Toast } from "vant";

import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  name: "RecordList",
  components: {
    Frame,
    RecordItem,
    FilterDialog,
    FilterStatusList
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const statusFilter = ref(null);

    // 筛选列表
    const filterList = ref([]);
    const statusList = params =>
      store.dispatch("studentLeave/statusList", params);
    const getFilterList = async () => {
      let r = await statusList();
      if (r.message === "success") {
        let list = r.data.list;
        list.map(item => {
          let temp = {
            name: item.name,
            value: item.code
          };
          filterList.value.push(temp);
        });
      } else {
        Toast.fail(r.message);
      }
    };
    getFilterList();

    const filterDialogShow = ref(false);
    const filterDialogCancleEvt = () => {
      filterDialogShow.value = false;
    };
    const filterDialogResetEvt = () => {
      statusFilter.value.resetEvt();
    };
    const filterDialogOkEvt = () => {
      pageIndex = 1;
      list.value = [];
      searchStatus.value = statusFilter.value
        ? statusFilter.value.activeIds
        : "";
      getApplyList();
      filterDialogShow.value = false;
    };
    const showDialog = () => {
      filterDialogShow.value = true;
    };

    // 消息列表
    let pageIndex = 1;
    let pageSize = 30;
    const searchStatus = ref([]);
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);

    const onLoad = () => {
      getApplyList();
    };

    // 下拉刷新
    const onRefresh = () => {
      // 清空列表数据
      list.value = [];
      pageIndex = 1;
      finished.value = false;
      onLoad();
    };

    // 获取申请列表
    const applyList = params =>
      store.dispatch("studentLeave/applyListParent", params);
    const getApplyList = async () => {
      let params = {
        bizType: "student_leave", // 业务类型 学生请假
        searchStatusList: searchStatus.value,
        pageNo: pageIndex,
        pageSize: pageSize
      };
      console.log("params",params)
      setTimeout(() => {
        loading.value = false;
        finished.value = true;
      }, 3000);
      let r = await applyList(params);
      if (r.message == "success") {
        if (refreshing.value) {
          list.value = [];
          refreshing.value = false;
        }
        list.value.push(...r.data.list);
        loading.value = false;
        pageIndex++;
        if (list.value.length >= r.data.total) {
          finished.value = true;
        }
      } else {
        refreshing.value = false;
        finished.value = true;
        loading.value = false;
        Toast.fail(r.message);
      }
    };
    getApplyList();

    // 跳转到详情页
    const navigateDetail = detail => {
      router.push({
        path: "/leaveDetail",
        query: {
          detail: detail
        }
      });
    };

    return {
      searchStatus,
      statusFilter,
      filterDialogShow,
      filterDialogCancleEvt,
      filterDialogResetEvt,
      filterDialogOkEvt,
      showDialog,
      onRefresh,
      filterList,
      list,
      loading,
      finished,
      refreshing,
      navigateDetail
    };
  }
};
</script>

<style lang="less" scoped>
.header-filter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 46px;
  padding: 0 15px;
}
</style>
